<template>
    <div id="navbar-container" :class="navbarClass">
      <!-- Logo -->
      <div id="logo" @click="routeHomePage">Serdar Kaynak</div>
  
      <!-- Hamburger Menü (Telefon için) -->
      <div class="hamburger-menu" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
  
      <div class="pages" :class="{ open: isMenuOpen }">
        <ul>
          <router-link to="/">
            <li><button @click="closeMenu">{{ $t('navbar.home') }}</button></li>
          </router-link>
          <router-link to="/exhibition">
            <li><button @click="closeMenu">{{ $t('navbar.exhibition') }}</button></li>
          </router-link>
          <router-link to="/portfolio">
            <li><button @click="closeMenu">{{ $t('navbar.portfolio') }}</button></li>
          </router-link>
          <router-link to="/bio">
            <li><button @click="closeMenu">{{ $t('navbar.biography') }}</button></li>
          </router-link>
          <router-link to="/contact">
            <li><button @click="closeMenu">{{ $t('navbar.contact') }}</button></li>
          </router-link>
          <li id="language"> <span @click="setTurkish">TR</span>/<span @click="setEnglish">EN</span></li>
        </ul>
      </div>
    </div>
  </template>
  
  <script>
  import { useLangStore } from '../../stores/langStore';

  export default {
    data() {
      return {
        isMenuOpen: false,
        langStore: useLangStore()
      };
    },
    computed: {
      navbarClass() {
        return this.$route.path !== "/" ? "nav-bar-dark" : "";
      },
    },
    methods: {
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
      },
      closeMenu(){
        this.isMenuOpen = false;
      },
      routeHomePage(){
        this.$router.push('/');
        this.isMenuOpen = false;
      },
      setTurkish(){
        this.langStore.setLanguage('tr');
        this.$i18n.locale = 'tr';
      },
      setEnglish(){
        this.langStore.setLanguage('en');
        this.$i18n.locale = 'en';
      }
    },
  };
  </script>

<style scoped>
/* Genel Navbar Stili */
#navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  width: 100%;
}
.nav-bar-dark {
  background-color: rgb(27, 27, 27);
}

/* Logo */
#logo {
  font-family: TheSignature;
  font-weight: 300;
  color: rgba(245, 245, 245, 0.884);
  font-size: 60px;
  margin-top: 2%;
  margin-left: 20px;
  cursor: pointer;
}

#language{
  color: rgba(245, 245, 245, 0.884);
  width: auto;
}

#language span{
  text-decoration: underline;
}

#language span:hover{
  cursor: pointer;
}

/* Hamburger Menü Stili */
.hamburger-menu {
  display: none; /* Masaüstünde gizlenir */
  flex-direction: column;
  cursor: pointer;
  margin-right: 20px;
}
.hamburger-menu span {
  background: rgba(245, 245, 245, 0.884);
  height: 3px;
  width: 25px;
  margin: 4px 0;
  border-radius: 5px;
}

/* Sayfa Bağlantıları */
.pages {
  display: flex;
  align-items: center;
  justify-content: end;
  margin-right: 2%;
}
.pages ul {
  display: flex;
  align-items: center;
  justify-content: end;
}
.pages li {
  list-style: none;
  margin-left: 10px;
}
.pages button {
  font-size: 18px;
  background: none;
  border: none;
  cursor: pointer;
  color: rgba(245, 245, 245, 0.884);
}

/* Mobil Cihazlar İçin */
@media (max-width: 768px) {
  #logo{
    margin-top: 2%;
  }
  
  /* Hamburger Menü Aktif Edilir */
  .hamburger-menu {
    display: flex;
  }

  /* Sayfa bağlantıları gizlenir ve açılır hale gelir */
  .pages {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 70px;
    right: 0;
    width: 100%;
    background-color: rgb(27, 27, 27);
    padding: 10px 0;
    z-index: 1000;
  }
  .pages.open {
    display: flex;
  }
  .pages ul {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    margin: 0;
  }
  .pages li {
    margin: 10px 20px;
  }
  #language {
    padding: 0;
  }
  #language span {
    padding: 10px;
  }
  .pages button {
    width: 100%;
    text-align: left;
    padding: 10px;
    color: white;
  }
}
</style>